"use strict";function t(o,r){return t=Object.setPrototypeOf?Object.setPrototypeOf.bind():function(e,n){return e.__proto__=n,e},t(o,r)}exports._setPrototypeOf=t;
